<template>
<div>
  <div class="form-list">
    <div class="form-header">선</div>
    <el-form :model="formModel" label-width="120px" label-position="left">
      <el-form-item label="모양">
        <el-row type="flex" :gutter="5" class="line-type-wrapper">
          <w-map-button icon="map-linetype5-btn" tooltip="직선" :pressed="formModel.lineDirection === 'EDGE_TYPE_DEFAULT'" @onClick="onLineDirectionClick('EDGE_TYPE_DEFAULT')"></w-map-button>
          <w-map-button icon="map-linetype1-btn" tooltip="가로 꺾은선1" :pressed="formModel.lineDirection === 'EDGE_TYPE_HORIZONTAL_VERTICAL'" @onClick="onLineDirectionClick('EDGE_TYPE_HORIZONTAL_VERTICAL')"></w-map-button>
          <w-map-button icon="map-linetype2-btn" tooltip="세로 꺾은선1" :pressed="formModel.lineDirection === 'EDGE_TYPE_VERTICAL_HORIZONTAL'" @onClick="onLineDirectionClick('EDGE_TYPE_VERTICAL_HORIZONTAL')"></w-map-button>
          <w-map-button icon="map-linetype4-btn" tooltip="가로 꺾은선2" :pressed="formModel.lineDirection === 'EDGE_TYPE_ORTHOGONAL_HORIZONTAL'" @onClick="onLineDirectionClick('EDGE_TYPE_ORTHOGONAL_HORIZONTAL')"></w-map-button>
          <w-map-button icon="map-linetype3-btn" tooltip="세로 꺾은선2" :pressed="formModel.lineDirection === 'EDGE_TYPE_ORTHOGONAL_VERTICAL'" @onClick="onLineDirectionClick('EDGE_TYPE_ORTHOGONAL_VERTICAL')"></w-map-button>
          <w-map-button icon="map-linetype6-btn" tooltip="곡선" :pressed="formModel.lineDirection === 'SEGMENT_CURVE_TO'" @onClick="onLineDirectionClick('SEGMENT_CURVE_TO')"></w-map-button>
        </el-row>
      </el-form-item>
      <el-form-item label="대시">
        <el-checkbox v-model="formModel.lineOptions.dashType" :true-label="'dash1'" :false-label="'default'"></el-checkbox>
      </el-form-item>
      <el-form-item label="화살표">
        <el-select v-model="formModel.lineOptions.arrowType" :style="fullField">
          <el-option label="없음" value="N"></el-option>
          <el-option label="출발지" value="S"></el-option>
          <el-option label="목적지" value="D"></el-option>
          <el-option label="둘다" value="B"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="두께">
        <el-input-number v-model="formModel.strokeOptions.weight" :min="1" :max="10" controls-position="right" :style="fullField"></el-input-number>
      </el-form-item>
      <el-form-item label="색상">
        <w-color-field v-model="formModel.strokeOptions.color" :style="fullField"></w-color-field>
      </el-form-item>
      <el-form-item label="각도">
        <el-select v-model="formModel.r" :style="fullField">
          <el-option label="가로" :value="0"></el-option>
          <el-option label="세로" :value="90"></el-option>
          <el-option label="좌측 대각선" :value="45"></el-option>
          <el-option label="우측 대각선" :value="-45"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="정상 색 표현">
        <el-checkbox v-model="formModel.styleOptions.showNormalColor"></el-checkbox>
      </el-form-item>
    </el-form>
  </div>
  <div class="form-list">
    <div class="form-header">인터페이스 연결</div>
    <el-form :model="formModel" label-width="120px" label-position="left">
      <el-form-item label="출발지" v-if="netdevice('from') !== null">
        <w-interface-select :object="netdevice('from')" direction="from"></w-interface-select>
      </el-form-item>
      <el-form-item label="목적지" v-if="netdevice('to') !== null">
        <w-interface-select :object="netdevice('to')" direction="to"></w-interface-select>
      </el-form-item>
      <el-form-item label="성능표현">
        <el-checkbox v-model="formModel.showTrafficLabel" true-label="1" false-label="0"></el-checkbox>
      </el-form-item>
      <el-form-item label="인터페이스명 표현">
        <el-checkbox v-model="formModel.lineOptions.showIfLabelCheckbox" true-label="1" false-label="0"></el-checkbox>
        <el-select v-model="formModel.lineOptions.showIfLabelCombobox" :style="fullField">
          <el-option label="별칭" value="alias"></el-option>
          <el-option label="이름" value="name"></el-option>
          <el-option label="설명" value="desc"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</div>
</template>

<script>
import { isEmpty } from 'lodash';
import WColorField from '@/components/form/ColorField';
import ObjectProperty from '@/mixins/topologymap/object-property';
import WMapButton from '@/views/topologymap/components/MapButton';
import WInterfaceSelect from '@/views/topologymap/components/property/InterfaceSelect';

export default {
  name: 'WLineProperty',
  components: {
    WColorField,
    WMapButton,
    WInterfaceSelect,
  },
  mixins: [ObjectProperty],
  data() {
    return {
    };
  },
  computed: {
    isAutomap() {
      return !isEmpty(this.$store.getters.getAutomapInfo);
    },
  },
  methods: {
    /**
     * 목적지/출발지에 따른 네트워크 장비 데이터를 반환한다.
     * @author KangBonghun(toto1323)
     * @param  {String} direction 방향 (from=출발지, to=목적지)
     * @return {Object}           [description]
     */
    netdevice(direction) {
      if (this.objects.length === 1) {
        const object = this.objects[0];
        const agent = object[direction];
        if (agent && agent.get('objDefineId') && agent.get('objDefineId') === 'NETDEVICE' && agent.get('isObj')) {
          if (this.isAutomap) {
            if (object.to.get('isAutomapDevice') && object.from.get('isAutomapDevice')) {
              return null;
            }
            return object;
          }
          return object;
        }
        return null;
      }
      return null;
    },
    /**
     * 선 모양 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} lineDirection [description]
     */
    onLineDirectionClick(lineDirection) {
      // 라인 모양을 변경하기 전에 꼭지점(PathSegments)를 제거해야 모양이 변경된다.
      this.objects.forEach((object) => {
        object.changeLineDirection();
      });

      this.formModel.lineDirection = lineDirection;
    },
  },
};
</script>
<style>
.line-type-wrapper > div:not(:last-child) {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/LineProperty.vue